module.exports = __webpack_public_path__ + "static/img/24.4f4b7c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/24.jpg
// module id = VZ9h
// module chunks = 16